import { useEffect, useState } from "react";
import axios from "axios";
import TPC_URL from "../../utils/TPC_URL";

export function useInsightwinProcessMaster(
  clickedProcId,
  group_code,
  project_code
) {
  const [processMasterData, setProcessMasterData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          TPC_URL +
            `/api/proc/getProcM?group_code=${group_code}&project_code=${project_code}`
        );
        // const res2 = await axios.get(
        //   TPC_URL +
        //     `/api/orders/getAllOrder?group_code=${group_code}&project_code=${project_code}`
        // );
        setProcessMasterData(res.data);
        setOrderData([]);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, [clickedProcId]);
  return {
    processMasterData,
    orderData,
  };
}

export function useInsightwinMachineMaster(group_code, project_code) {
  const [machineMasterData, setMachineMasterData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          TPC_URL +
            `/api/mch/getAllMachine?group_code=${group_code}&project_code=${project_code}`
        );
        setMachineMasterData(res.data);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, []);
  return {
    machineMasterData,
  };
}

export const useInformationData = (group_code, project_code) => {
  const [loading, setLoading] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [infoData, setInfoData] = useState({});
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        let initialData = {};
        const res = await axios.get(
          TPC_URL +
            `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
        );
        initialData.item = res.data;
        setInfoData(initialData);
        setLoading(false);
        initialData = null;
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchDataAgain() {
      try {
        if (updateStatus) {
          setLoading(true);
          // 29 자리에 user.username
          let initialData = {};
          const res = await axios.get(TPC_URL + "/getInsightwinItemList");
          // const machineList = await axios.get(
          //   API_URL + "/getInsightwinMachineList"
          // );
          // const processList = await axios.get(
          //   API_URL + "/getInsightwinProcessList"
          // );
          // const orderList = await axios.get(
          //   API_URL + "/api/orders/getAllOrder"
          // );
          // const lotList = await axios.get(API_URL + "/getInsightwinLotList");
          // const res = await axios.get(`${API_URL}/getItemList?username=user29`);
          // const machineList = await axios.get(
          //   `${API_URL}/getMachineList?username=user29`
          // );
          // const processList = await axios.get(
          //   `${API_URL}/getProcessList?username=user29`
          // );
          // const orderList = await axios.get(
          //   `${API_URL}/getOrderList?username=user29`
          // );
          initialData.item = res.data[0];
          // initialData.machine = machineList.data[0];
          // initialData.process = processList.data[0];
          // initialData.order = orderList.data[0];
          // initialData.lot = lotList.data[0];
          setInfoData(initialData);
          setLoading(false);
          initialData = null;
          setUpdateStatus(false);
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
        setUpdateStatus(false);
      }
    }
    fetchDataAgain();
  }, [updateStatus]);
  return {
    loading,
    setUpdateStatus,
    infoData,
    setInfoData,
  };
};

export default useInformationData;
